import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SpinnerService {

    private list = [];
    get isLoading() {
        return this.list.length > 0;
    }

    constructor() { }

    startLoad(key: string) {
        this.list.push(key);
    }

    finishLoad(key: string) {
        var index = this.list.indexOf(key);
        this.list.splice(index, 1);
    }
}
